import React, { FC, useEffect, useState } from 'react';
import { Loader } from './components/loader';
import { ResultBlock } from './components/resultBlock';
import { ValuesBlock } from './components/valuesBlock';
import { GENDER_VALUES, HEIGHT_VALUES, WEIGHT_VALUES } from './constants';
import { getGoalDate, getMonthsCountToReachTheGoal } from 'helpers';
import verv from './img/verv.png';
import * as S from './styled';
import { appStore } from '@store';

export const OneMinuteQuiz: FC = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [isShowResults, setIsShowResults] = useState(false);
	const [gender, setGender] = useState(GENDER_VALUES.FEMALE);
	const [heightUnit, setHeightUnit] = useState(HEIGHT_VALUES.FT);
	const [heightValue, setHeightValue] = useState('');
	const [currentWeightValue, setCurrentWeightValue] = useState('');
	const [goalWeightValue, setGoalWeightValue] = useState('');
	const [weightUnit, setWeightUnit] = useState(WEIGHT_VALUES.LBS);
	const [isInputEmpty, setIsInputEmpty] = useState(true);

	const genderChangeHandler = (e: any) => {
		setGender(e.target.value);
	};

	const heightUnitChangeHandler = (e: any) => {
		setHeightUnit(e.target.value);
		setHeightValue('');
		if (heightUnit === HEIGHT_VALUES.FT) {
			setWeightUnit(WEIGHT_VALUES.KG);
		} else {
			setWeightUnit(WEIGHT_VALUES.LBS);
		}
	};
	const heightValueChangeHandler = (e: any) => {
		if (heightUnit === HEIGHT_VALUES.FT && heightValue.length < 4) {
			setHeightValue((e.target.value as string) + '’');
			if (heightValue.length >= 2) {
				setHeightValue((e.target.value as string) + '”');
			}
		} else if (heightUnit === HEIGHT_VALUES.CM && heightValue.length < 6) {
			setHeightValue(e.target.value);
		}
		e.target.onkeydown = function (e: any) {
			if (e.keyCode === 8) {
				setHeightValue('');
			}
		};
	};

	const weightUnitChangeHandler = (e: any) => {
		setWeightUnit(e.target.value);
		setHeightValue('');
		if (weightUnit === WEIGHT_VALUES.LBS) {
			setHeightUnit(HEIGHT_VALUES.CM);
			setWeightUnit(WEIGHT_VALUES.KG);
		} else {
			setHeightUnit(HEIGHT_VALUES.FT);
			setWeightUnit(WEIGHT_VALUES.LBS);
		}
	};

	const currentWeightValueChangeHandler = (e: any) => {
		if (currentWeightValue.length < 6) {
			setCurrentWeightValue(e.target.value);
		}
		e.target.onkeydown = function (e: any) {
			if (e.keyCode === 8) {
				setCurrentWeightValue('');
			}
		};
	};
	const goalWeightValueChangeHandler = (e: any) => {
		if (goalWeightValue.length < 6) {
			setGoalWeightValue(e.target.value);
		}
		e.target.onkeydown = function (e: any) {
			if (e.keyCode === 8) {
				setGoalWeightValue('');
			}
		};
	};

	const onCalculateButtonClickHandler = () => {
		setIsLoading(true);
		setTimeout(() => {
			setIsLoading(false);
			setIsShowResults(true);
			appStore.paywallStore.setHideOptionPrices(false);
		}, 3500);
	};

	const goalDate = getGoalDate(+currentWeightValue, +goalWeightValue);
	const monthsCount = getMonthsCountToReachTheGoal(+currentWeightValue, +goalWeightValue);

	const isInputsEmpty = () => {
		const reg = /^\d+(?:[.,]\d{1,3})?$/;
		const testHeight = heightValue.length > 0;
		const testCurrentWeight = reg.test(currentWeightValue);
		const testGoalWeight = reg.test(goalWeightValue);
		return testHeight && testCurrentWeight && testGoalWeight;
	};

	useEffect(() => {
		setIsInputEmpty(!isInputsEmpty());
	}, [heightValue, currentWeightValue, goalWeightValue]);

	const propsResultBlock = {
		isShowResults,
		currentWeightValue: +currentWeightValue,
		goalWeightValue: +goalWeightValue,
		weightUnit,
		goalDate,
		monthsCount,
	};

	const propsValuesBlock = {
		gender,
		heightValue,
		heightUnit,
		currentWeightValue,
		weightUnit,
		goalWeightValue,
		isInputEmpty,
		onCalculateButtonClick: onCalculateButtonClickHandler,
		onChangeGender: genderChangeHandler,
		onChangeHeightUnit: heightUnitChangeHandler,
		onChangeHeightValue: heightValueChangeHandler,
		onChangeWeightUnit: weightUnitChangeHandler,
		onChangeCurrentWeightValue: currentWeightValueChangeHandler,
		onChangeGoalWeightValue: goalWeightValueChangeHandler,
	};

	return (
		<S.Container>
			<S.Logo>
				<S.Image src={verv} width={34} height={34} alt='verv' /> Verv: Home Fitness Workout
			</S.Logo>
			<S.Title>1-MINUTE QUIZ</S.Title>
			<S.Content>
				<ResultBlock {...propsResultBlock} />
				<Loader isLoading={isLoading} />
				<ValuesBlock {...propsValuesBlock} />
			</S.Content>
		</S.Container>
	);
};
